<template>
  <div class="custom-page-design-container">
    <div class="top-box-shadow"></div>
    <div class="custom-page-design-content">
      <div class="custom-page-design-left">
        <div class="title">添加组件</div>
        <div class="controls">
          <div class="control" v-for="item in basicsControls" :key="item.url" @click="openDialog(item)">
            <img :src="item.url" :alt="item.name">
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
      <div class="custom-page-design-right" :style="setBackgroundImg">
        <div v-if="choiceControls.length === 0" class="none-controls">从左侧添加组件，开始创建页面</div>
        <div class="custom-page-design-controls" ref="controls">
          <div v-if="showControlMoveModel === item.id" class="control control-move-model" v-for="item in choiceControls"
               :key="item.id + new Date().valueOf()" :style="getStyle(item)">
            <div class="control-move-model-body"></div>
          </div>
          <div :class="['control', addAnimate && 'control-animated', showControlMoveModel === item.id && 'set-z-index']"
               v-for="(item, i) in choiceControls" :key="item.id" :style="getStyle(item)" :ref="item.id + 'control'">
            <div :class="['control-body', isUpdateSize === item.id && 'cursor-resize']"
                 :ref="item.id"
                 @mouseover.stop="startDraggable(item)"
                 @mouseout.stop="isMove = null"
                 :style="{'background-color': getBgc(item.backgroundAndBorder, item), 'border': getBorder(item.backgroundAndBorder), 'background-image': getBgcImg(item.backgroundAndBorder), 'opacity': item.type === 'decorate' ? parseFloat(item.decorateOpacity) / 100 : 1}">
              <!-- 6个自定义页面 -->
              <div v-if="item.headTitle.show" class="control-title">
                <el-input v-model="item.headTitle.value" placeholder="标题" :ref="`${item.id}-title`"
                          :title="item.headTitle.value" :style="getFontStyle(item.titleFont)"></el-input>
              </div>
              <div :class="['control-content', item.headTitle.show && 'control-content-has-title']">
                <template v-if="item.type === 'diagram'">
                  <diagram :data="item" :showOperation="false" :ref="`${item.id}-diagram`"></diagram>
                </template>
                <template v-else-if="item.type === 'rich-text-box'">
                  <div class="rich-value" v-html="item.richValue"></div>
                  <div v-if="isUpdateSize !== '' || showControlMoveModel !== ''"
                       :class="['iframe-model', isUpdateSize === item.id || showControlMoveModel === item.id && 'set-z-index']"></div>
                </template>
                <template v-else-if="item.type === 'url-page'">
                  <iframe width="100%" height="100%" :src="disposeUrl(item)" frameborder="0"></iframe>
                  <div v-if="isUpdateSize !== '' || showControlMoveModel !== ''"
                       :class="['iframe-model', isUpdateSize === item.id || showControlMoveModel === item.id && 'set-z-index']"></div>
                </template>
                <template v-else-if="item.type === 'report'">
                  <report :data="item" :showOperation="false" :ref="`${item.id}-report`"></report>
                </template>
                <template v-else-if="item.type === 'calendar'">
                  <calendar :typeFlag=1 :ref="`${item.id}-calendar`"></calendar>
                </template>
                <template v-else-if="item.type === 'clock'">
                  <clock :data="item" :sceneType=1 :ref="`${item.id}-clock`"></clock>
                </template>
                <template v-else-if="item.type === 'text-control'">
                  <div class="text-control" :style="getFontStyle(item.textFont)">{{item.textContent}}</div>
                </template>
                <template v-else-if="item.type === 'decorate'">
                  <img class="decorate-img" :src="item.decorateUrl" draggable="false">
                </template>
              </div>
            </div>
            <span :class="['el-icon-arrow-down', isUpdateSize === item.id && 'active']" :ref="`${item.id}${i}`"
                  @mouseover.stop="dragControlSize(item, i)" @mouseout="removeEvent(item, i)"></span>
            <div v-show="isMove === item.id" :class="['control-operation', item.headTitle.show && 'have-title-top', (item.type === 'text-control' || item.type === 'decorate') && 'update-width']"
                 @mouseover="isMove = item.id">
              <el-popover title="" placement="bottom" trigger="hover" content="设置" popper-class="custom-page-popper"
                          :closeDelay="0">
                <span slot="reference" class="el-icon-edit" @click="openDialog(item)"></span>
              </el-popover>
              <el-popover v-if="item.type !== 'text-control' && item.type !== 'decorate'" title="" placement="bottom"
                          trigger="hover" :content="item.headTitle.show ? '取消标题行' : '插入标题行'"
                          popper-class="custom-page-popper" :closeDelay="0">
                <span slot="reference" class="fa fa-text-height" @click="insertTitle(item)"></span>
              </el-popover>
              <el-popover title="" placement="bottom" trigger="hover" content="删除" popper-class="custom-page-popper"
                          :closeDelay="0">
                <span slot="reference" class="el-icon-error" @click="deleteControl(item)"></span>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :class="(dialog.data.type === 'text-control') && 'no-title-dialog'"
      class="custom-page-design-dialog"
      top="10vh"
      :visible.sync="dialog.visable"
      width="1100px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      center
      @close="closeDialog">
      <div v-if="dialog.data.type !== 'text-control' && dialog.data.type !== 'decorate'" class="custom-page-design-dialog-title" slot="title">
        <div :class="['title', showInput && 'show-input-width']" ref="customPageDesignDialogTitle"
             :title="dialog.title">
          <template v-if="!showInput">{{dialog.title || '未命名'}}</template>
          <template v-else>
            <el-input placeholder="未命名" :style="{width: inputWidth}" v-model="dialog.title" clearable
                      ref="titleInput"></el-input>
          </template>
        </div>
        <div class="operation"><i class="el-icon-edit" @click="showInput = !showInput"></i></div>
      </div>
      <div v-else-if="dialog.data.type === 'decorate'" slot="title">装饰</div>
      <div class="dialog-body">
        <component v-if="dialog.visable" :is="dialog.type" :data="dialog.data" @addControls="addControls"
                   @closeDialog="closeDialog" :getStyleSetting="dialog.getStyleSetting" :getStyleWithStyleList="dialog.getStyleWithStyleList"></component>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import diagram from './diagram'
import richTextBox from './rich-text-box'
import urlPage from './url-page'
import Controls from './assets/js/controls'
import report from './report'
import calendar from './calendar'
import clock from './clock'
import textControl from './text-control'
import decorate from './decorate'
import setStyle from '../../../public/setStyle'
export default {
  name: 'custom-page-design',
  props: ['choiceControls', 'report'],
  mixins: [setStyle],
  data () {
    return {
      basicsControls: [
        {name: '报表', url: require('./assets/images/report.png'), title: '报表', type: 'report'},
        {name: '统计图', url: require('./assets/images/diagram.png'), title: '统计图设置', type: 'diagram'},
        {name: '富文本', url: require('./assets/images/rich-text-box.png'), title: '富文本', type: 'rich-text-box'},
        {name: '文本', url: require('./assets/images/input.png'), title: '文本', type: 'text-control'},
        {name: '嵌入url', url: require('./assets/images/url.png'), title: '嵌入url', type: 'url-page'},
        {name: '日历', url: require('./assets/images/calendar.png'), title: '日历', type: 'calendar'},
        {name: '时钟', url: require('./assets/images/clock.png'), title: '时钟', type: 'clock'},
        {name: '装饰', url: require('./assets/images/decorate.png'), title: '装饰', type: 'decorate'}
      ],
      dialog: {
        visable: false,
        title: '',
        type: '',
        data: {},
        getStyleSetting: function (args) {},
        getStyleWithStyleList: function (args = []) {}
      },
      addAnimate: false,
      isMove: null,
      isUpdateSize: '',
      showControlMoveModel: null,
      // 判断元素是否能放置下
      moveParams: {
        canMove: false,
        left: 0,
        top: 0
      },
      showInput: false,
      inputWidth: '100%',
      background: {
        src: '',
        repeat: ''
      }
    }
  },
  components: {
    diagram,
    richTextBox,
    urlPage,
    report,
    calendar,
    clock,
    textControl,
    decorate
  },
  methods: {
    // 元素移动
    startDraggable (item) {
      this.isMove = item.id
      let self = this
      let cs = this.$refs.controls
      let dom = this.$refs[item.id][0]
      let control = this.getControlEl(item)
      let list = this.choiceControls.filter(c => c.id !== item.id)
      let maxZindex = this.$_.maxBy(list, c => c.zIndex)
      dom.onmousedown = e => {
        let x = e.clientX
        let y = e.clientY
        document.onmousemove = ev => {
          self.showControlMoveModel = item.id
          let width = ev.clientX - x + item.position.left
          let height = ev.clientY - y + item.position.top
          if (width <= 0) {
            width = 0
          } else if (width + item.width >= (cs.offsetWidth - 15)) {
            width = cs.offsetWidth - item.width - 15
          }
          if (height <= 15) {
            height = 15
          }
          this.scrollControlsDown(height)
          control.style.left = width + 'px'
          control.style.top = height + 'px'
          if (control.type !== 'text-control') {
            control.style.zIndex = maxZindex ? (maxZindex.zIndex + 1) : parseInt(control.style.zIndex) + 1
          } else {
            control.style.zIndex = '9999'
          }
          // 改方法有bug。后期修复
          // self.controlMoveLater(item, control)
        }
        document.onmouseup = () => {
          // 只有可以放置的时候才能修改，否则恢复
          // if (self.moveParams.canMove) {
          //   let width = self.moveParams.left
          //   let height = self.moveParams.top
          //   if (width <= 0) {
          //     width = 0
          //   } else if (width + item.width >= (cs.offsetWidth - 15)) {
          //     width = cs.offsetWidth - item.width - 15
          //   }
          //   if (height <= 15) {
          //     height = 15
          //   } else if (height + item.height >= cs.scrollHeight) {
          //     height = cs.scrollHeight - item.height
          //   }
          //   control.style.left = width + 'px'
          //   control.style.top = height + 'px'
          //   self.setControlsPositionWithStyle()
          // } else {
          //   control.style.left = item.position.left + 'px'
          //   control.style.top = item.position.top + 'px'
          // }
          // self.$set(this, 'moveParams', {
          //   canMove: false,
          //   left: 0,
          //   top: 0
          // })
          self.showControlMoveModel = null
          this.setControlsPositionWithStyle(item)
          document.onmousemove = document.onmouseup = null
        }
      }
    },
    // 缩放
    dragControlSize (item, i) {
      let findControl = this.choiceControls.find(c => c.id === item.id)
      let self = this
      let dom = this.$refs[`${item.id}${i}`][0]
      let canvasWidth = this.$refs.controls.offsetWidth - 15
      let maxWidth = canvasWidth - item.position.left
      let control = this.getControlEl(item)
      let list = this.choiceControls.filter(c => c.id !== item.id)
      let maxZindex = list.length > 0 ? this.$_.maxBy(list, c => c.zIndex) : item.zIndex
      dom.onmousedown = e => {
        self.isUpdateSize = item.id
        e = e || event
        let x = e.clientX - dom.offsetLeft
        let y = e.clientY - dom.offsetTop
        let width = parseFloat(control.style.width)
        let height = parseFloat(control.style.height)
        document.onmousemove = ev => {
          ev = ev || event
          width = ev.clientX - x + dom.offsetWidth
          height = ev.clientY - y + dom.offsetHeight + 15
          // 时间和文本控件不需要限制缩放大小
          if (item.type !== 'clock' && item.type !== 'text-control') {
            let maxH = findControl.headTitle.show ? 228 : 200
            width = width <= 250 ? 250 : width >= maxWidth ? maxWidth : width
            height = height <= maxH ? maxH : height
          }
          control.style.width = width + 'px'
          control.style.height = height + 'px'
          this.scrollControlsDown()
          // 判断是否可以缩放，暂时留着
          // if (self.judgeIsHaveControl(item, 20).isHave) {
          //   control.style.width = width + 'px'
          //   control.style.height = height + 'px'
          // } else {
          //   ev = ev || event
          //   width = ev.clientX - x + dom.offsetWidth
          //   height = ev.clientY - y + dom.offsetHeight + 15
          //   let maxH = findControl.headTitle.show ? 228 : 200
          //   width = width <= 250 ? 250 : width >= maxWidth ? maxWidth : width
          //   height = height <= maxH ? maxH : height
          //   control.style.width = width + 'px'
          //   control.style.height = height + 'px'
          // }
        }
        document.onmouseup = en => {
          self.isUpdateSize = ''
          let width = parseFloat(control.style.width)
          let height = parseFloat(control.style.height)
          self.$set(findControl, 'width', width)
          self.$set(findControl, 'height', height)
          self.$set(findControl, 'ratio', width / canvasWidth)
          if (findControl.type !== 'text-control') {
            self.$set(findControl, 'zIndex', maxZindex ? (maxZindex.zIndex + 1) : parseInt(control.style.zIndex) + 1)
          }
          this.$refs[`${findControl.id}-diagram`] && this.$refs[`${findControl.id}-diagram`][0].resizeChartSize()
          document.onmousemove = document.onmouseup = null
          //  更改报表大小
          if (item.type === 'report') {
            let report = self.$children.filter(n => {
              if (n.data && n.data.id && (n.data.id === item.id)) {
                return n
              }
            })[0]
            report.flag++
          }
        }
      }
    },
    async openDialog (data) {
      this.isMove = this.isMove ? null : this.isMove
      let params = new Controls(data)
      this.dialog.title = data.headTitle ? data.headTitle.value : params.headTitle.value
      this.dialog.data = this.clearJoin(params)
      this.dialog.type = params.type
      // 获取样式的默认值，用于恢复默认设置操作
      this.dialog.getStyleSetting = params.getStyleSetting
      // 根据 styleList 获取style
      this.dialog.getStyleWithStyleList = params.getStyleWithStyleList
      this.$nextTick(() => {
        this.dialog.visable = true
      })
    },
    async addControls (data, close) {
      this.showInput = false
      let index = this.choiceControls.findIndex(c => c.id === data.id)
      if (index !== -1) {
        //  已存在id。编辑图表
        data.headTitle.value = this.dialog.title
        this.$set(this.choiceControls, index, this.clearJoin(data))
        this.$refs[`${data.id}-diagram`] && this.$refs[`${data.id}-diagram`][0].initCreated(true)
        this.$nextTick(() => {
          this.$refs[`${data.id}-report`] && this.$refs[`${data.id}-report`][0].initCreated(true)
        })
      } else {
        //  不存在id。新增图表
        let canvasWidth = this.$refs.controls.offsetWidth - 15
        let control = this.$_.merge(data, {width: canvasWidth / 2})
        control.position = await this.getPosition(control)
        this.choiceControls.push(control)
        let scroll = this.$refs.controls
        if (control.height + control.position.top >= scroll.scrollHeight) {
          this.scrollDown()
        }
      }
      close && this.$nextTick(() => {
        this.disposeImgStyle()
        this.closeDialog()
      })
    },
    getPosition (control) {
      return new Promise(resolve => {
        if (this.$refs.controls) {
          let position = this.calculatePosition(control)
          position && resolve(position)
        }
      })
    },
    calculatePosition (control) {
      let position = {}
      let isStart = true
      // 默认top为15
      let top = 15
      while (isStart) {
        // 首先判断是否有元素在左右都有部分
        let leftControls = this.findControlsWithPosition('left', control, top)
        let rightControls = this.findControlsWithPosition('right', control, top)
        let leftAndRight = this.findControlsWithPosition('leftAndRight', control, top)
        if (leftAndRight && leftAndRight.length !== 0) {
          let maxTop = this.$_.sortBy(leftAndRight, c => c.position.top)
          top = maxTop[maxTop.length - 1].position.top + maxTop[maxTop.length - 1].height
        } else {
          // 左边没有则放在左边
          if (leftControls && leftControls.length === 0) {
            isStart = false
            position = {left: 0, top}
          } else if (rightControls && rightControls.length === 0) {
            isStart = false
            position = {left: control.width, top}
          } else {
            let sortLeftControls = this.$_.sortBy(leftControls, c => c.position.top)
            let sortRightControls = this.$_.sortBy(rightControls, c => c.position.top)
            let maxLeft = sortLeftControls[sortLeftControls.length - 1]
            let maxRight = sortRightControls[sortRightControls.length - 1]
            // 默认放在左边
            if (maxLeft.position.top + maxLeft.height >= maxRight.position.top + maxRight.height) {
              top = maxRight.position.top + maxRight.height
            } else {
              top = maxLeft.position.top + maxLeft.height
            }
          }
        }
      }
      return position
    },
    findControlsWithPosition (position, control, height) {
      // 寻找当前行在左侧的所有控件
      let startTop = height
      let endTop = height + control.height
      let list = this.choiceControls.filter(c => c.id !== control.id)
      if (position === 'left') {
        return list.filter(c => {
          let el = this.getElStyle(this.getControlEl(c))
          return el.left < control.width && !(el.th <= startTop || el.top >= endTop)
        })
      } else if (position === 'right') {
        return list.filter(c => {
          let el = this.getElStyle(this.getControlEl(c))
          return el.left >= control.width && !(el.th <= startTop || el.top >= endTop)
        })
      } else if (position === 'leftAndRight') {
        return list.filter(c => {
          let el = this.getElStyle(this.getControlEl(c))
          return el.left < control.width && el.lw > control.width && !(el.th <= startTop || el.top >= endTop)
        })
      }
    },
    scrollDown () {
      this.$nextTick(() => {
        let scroll = this.$refs.controls
        if (scroll.scrollHeight > scroll.clientHeight) {
          scroll.scrollTop = scroll.scrollHeight - scroll.clientHeight
        }
      })
    },
    deleteControl (item) {
      this.$confirm('', '您确定要删除该组件么？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'publishMessageBox',
        center: true
      }).then(() => {
        this.addAnimate = true
        let control = this.clearJoin(item)
        this.choiceControls.splice(this.choiceControls.findIndex(c => c.id === control.id), 1)
        this.$nextTick(this.moveControl(control))
      })
    },
    // 删除元素之后，需要将下面的元素往上移动
    moveControl (item) {
      let findControls = this.findControlsWithSection(item)
      findControls.forEach(f => {
        f.position.top -= item.height
      })
      setTimeout(() => { this.addAnimate = false }, 1000)
    },
    removeEvent (item, i) {
      this.$refs[`${item.id}${i}`][0].removeEventListener('mousedown', () => {})
    },
    closeDialog () {
      this.showInput = false
      this.$set(this, 'dialog', {visable: false, title: '', type: '', data: {}})
    },
    clearJoin (object) {
      return JSON.parse(JSON.stringify(object))
    },
    insertTitle (item) {
      // 文本和装饰不需要插入标题
      if (item.type === 'text-control' || item.type === 'decorate') return false
      if (!item.headTitle.show) {
        item.headTitle.show = true
        this.$nextTick(() => this.$refs[`${item.id}-title`][0].focus())
      } else {
        item.headTitle.show = false
      }
      this.$nextTick(() => {
        this.$refs[`${item.id}-diagram`] && this.$refs[`${item.id}-diagram`][0].resizeChartSize()
        this.$refs[`${item.id}-report`] && this.$refs[`${item.id}-report`][0].resizeChartSize()
      })
    },
    // 将当前元素下面的元素向下移动title的距离
    updateControlTopWithTitle (control, distance) {
      let x = control.position.left
      let w = x + control.width
      let h = control.height + control.position.top - distance
      let findControl = this.choiceControls.filter(c => c.position.top >= h && !(c.position.left >= w || c.position.left + c.width <= x))
      findControl && findControl.forEach(f => { f.position.top += distance })
    },
    // 修改元素的 style 属性
    /**
       * xDistance：x轴位移的距离
       * yDistance：y轴位移的距离
       * beyondDistance：
       * */
    updateControlStyle (control, xDistance, yDistance) {
      // 如果该区间没有元素，则直接移动
      let controlEl = this.getElStyle(this.getControlEl(control))
      let beyondDistance = control.height * 0.25
      let minus = 20
      let isHave = this.judgeIsHaveControl(control, minus).isHave
      let minusControls = this.judgeIsHaveControl(control, minus).c
      let noMinusControl = this.judgeIsHaveControl(control, 0).c
      if (isHave) {
        // 在当前元素下面的可移动元素
        let canMoveControls = this.findControlsWithSection(control)
        if (yDistance > 0) {
          if (canMoveControls && canMoveControls.length) {
            // 获取元素下面的第一个元素
            let recentlyControl = this.$_.minBy(canMoveControls, c => parseFloat(this.getControlEl(c).style.top))
            let el = this.getControlEl(recentlyControl)
            let elStyle = this.getElStyle(el)
            // 判断是否能放得下
            if ((yDistance + beyondDistance >= elStyle.height) && (controlEl.left < elStyle.left + elStyle.width)) {
              this.moveParams.canMove = true
              el.style.top = control.position.top + 'px'
              this.moveParams.left = elStyle.left
              this.moveParams.top = parseFloat(el.style.top) + elStyle.height
            }
          }
        } else {
          canMoveControls = this.findControlsWithSection(control, 'top')
          if (canMoveControls && canMoveControls.length) {
            // 获取元素下面的第一个元素
            let recentlyControl = this.$_.maxBy(canMoveControls, c => parseFloat(this.getControlEl(c).style.top))
            let el = this.getControlEl(recentlyControl)
            let elStyle = this.getElStyle(el)
            yDistance = Math.abs(yDistance)
            // 判断是否能放得下
            if ((yDistance + beyondDistance >= elStyle.height) && (controlEl.left < elStyle.left + elStyle.width)) {
              this.moveParams.canMove = true
              this.moveParams.left = elStyle.left
              this.moveParams.top = elStyle.top
              el.style.top = controlEl.top + controlEl.height + 'px'
            }
          }
        }
      } else {
        if (JSON.stringify(minusControls) !== JSON.stringify(noMinusControl)) {
          let maxTop = this.$_.maxBy(noMinusControl, c => parseFloat(this.getControlEl(c).style.top))
          let maxLeft = this.$_.maxBy(noMinusControl, c => parseFloat(this.getControlEl(c).style.left))
          this.moveParams.canMove = true
          this.moveParams.left = maxLeft.position.left - control.width
          this.moveParams.top = maxTop.position.top - control.height
        } else {
          // 在当前元素下面的可移动元素
          this.moveParams.canMove = true
          this.moveParams.left = controlEl.left
          this.moveParams.top = controlEl.top
        }
      }
    },
    controlMoveLater (control, ref) {
      let xDistance = parseFloat(ref.style.left) - control.position.left
      let yDistance = parseFloat(ref.style.top) - control.position.top
      this.updateControlStyle(control, xDistance, yDistance)
    },
    setControlsPositionWithStyle (control = null) {
      if (control) {
        let el = this.getControlEl(control)
        this.$set(control.position, 'left', parseFloat(el.style.left))
        this.$set(control.position, 'top', parseFloat(el.style.top))
        if (control.type !== 'text-control') {
          this.$set(control, 'zIndex', parseFloat(el.style.zIndex))
        }
      } else {
        this.choiceControls.forEach(c => {
          let el = this.getControlEl(c)
          if (el) {
            this.$set(c.position, 'left', parseFloat(el.style.left))
            this.$set(c.position, 'top', parseFloat(el.style.top))
            if (control.type !== 'text-control') {
              this.$set(control, 'zIndex', parseFloat(el.style.zIndex))
            }
          }
        })
      }
    },
    // 寻找某个元素区间内和下面的元素
    findControlsWithSection (control, position = 'bottom') {
      let leftControls = this.findControlsWithStyle('left', control, control.position.top)
      let rightControls = this.findControlsWithStyle('right', control, control.position.top)
      // 可以移动的元素的区间 最小值
      let x = 0
      // 可以移动的元素的区间 最大值
      let mx = this.$refs.controls.offsetWidth - 15
      if (leftControls && leftControls.length) {
        x = this.$_.max(leftControls.map(m => m.position.left + m.width))
      }
      if (rightControls && rightControls.length) {
        mx = this.$_.min(rightControls.map(m => m.position.left))
      }
      let list = this.choiceControls.filter(c => c.id !== control.id)
      if (position === 'bottom') {
        // 找出在 x-mx 区间，并且在当前元素下面的元素
        return list.filter(c => c.position.left >= x && c.position.left + c.width <= mx && c.position.top >= control.position.top + control.height)
      } else if (position === 'top') {
        // 找出在 x-mx 区间，并且在当前元素上面的元素
        return list.filter(c => c.position.left >= x && c.position.left + c.width <= mx && c.position.top < control.position.top + control.height)
      }
      // 找出这个区间上下的元素
      return list.filter(c => c.position.left >= x && c.position.left + c.width <= mx)
    },
    findControlsWithStyle (position, control, height) {
      // 寻找当前行在左侧的所有控件
      let startTop = height
      let endTop = height + control.height
      let list = this.choiceControls.filter(c => c.id !== control.id)
      if (position === 'left') {
        return list.filter(c => {
          let el = this.getElStyle(this.getControlEl(c))
          return el.left < control.width && !(el.top + el.height <= startTop || el.top >= endTop)
        })
      } else if (position === 'right') {
        return list.filter(c => {
          let el = this.getElStyle(this.getControlEl(c))
          return el.left >= control.width && !(el.top + el.height <= startTop || el.top >= endTop)
        })
      }
    },
    // 判断当前元素位置是否有元素
    judgeIsHaveControl (control, minus) {
      let isHave = false
      let c = []
      let list = this.choiceControls.filter(c => c.id !== control.id)
      let controlEl = this.getElStyle(this.getControlEl(control))
      if (controlEl) {
        let left = controlEl.left + minus
        let top = controlEl.top + minus
        let lw = controlEl.lw - 2 * minus
        let th = controlEl.th - 2 * minus
        let findControls = list.filter(c => {
          let el = this.getElStyle(this.getControlEl(c))
          return el.lw <= left || el.left >= lw || el.th <= top || el.top >= th
        })
        if (findControls.length !== list.length) {
          c = list.filter(f => !findControls.find(x => x.id === f.id))
          isHave = true
        }
      }
      return {isHave, c}
    },
    getControlEl (control) {
      return this.$refs[`${control.id}control`] ? this.$refs[`${control.id}control`][0] : undefined
    },
    getElStyle (el) {
      if (!el) {
        return el
      }
      return {
        top: parseFloat(el.style.top),
        left: parseFloat(el.style.left),
        height: parseFloat(el.style.height),
        width: parseFloat(el.style.width),
        th: parseFloat(el.style.top) + parseFloat(el.style.height),
        lw: parseFloat(el.style.width) + parseFloat(el.style.left)
      }
    },
    scrollControlsDown (height) {
      this.$nextTick(() => {
        let scroll = this.$refs.controls
        if (scroll.scrollHeight > scroll.clientHeight && height + 20 > scroll.clientHeight) {
          scroll.scrollTop = scroll.scrollTop + 38
        }
      })
    },
    disposeImgStyle () {
      let dom = document.getElementsByClassName('rich-value')
      if (dom && dom.length > 0) {
        for (let i = 0; i < dom.length; i++) {
          // 只处理一层
          let p = dom[i].getElementsByTagName('p')
          if (p && p.length > 0) {
            for (let j = 0; j < p.length; j++) {
              let img = p[j].querySelector('img')
              let iframe = p[j].querySelector('iframe')
              if (img || iframe) {
                p[j].style.width = '100%'
                p[j].style.height = '100%'
              }
            }
          }
        }
      }
    }
  },
  computed: {
    getStyle () {
      return item => {
        return {
          'top': item.position.top + 'px',
          'left': item.position.left + 'px',
          'width': item.width + 'px',
          'height': item.height + 'px',
          'z-index': item.type === 'text-control' ? '9999' : item.zIndex
        }
      }
    },
    disposeUrl () {
      return item => {
        let reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
        return reg.test(item.urlValue) ? item.urlValue : `https://${item.urlValue}`
      }
    },
    setBackgroundImg () {
      return this.background.src ? {
        'background-image': `url("${this.background.src.includes('/ak0000000386') ? sessionStorage.getItem('ossDownloadUrl') + this.background.src : this.background.src}")`,
        'background-size': '100% 100%',
        'background-repeat': 'no-repeat'
      } : ''
    }
  },
  mounted () {
    this.disposeImgStyle()
    if (this.report) {
      this.background = this.report.background
    }
  },
  watch: {
    showInput (val) {
      if (val) {
        this.$nextTick(() => this.$refs.titleInput && this.$refs.titleInput.focus())
      }
    }
  }
}
</script>

<style lang="scss">
  .custom-page-design-container {
    width: 100%;
    height: 100%;
    background-color: #F5F9FE;
    border: 1px solid #E6E6E6;
    border-radius: 4px;
    border-top-left-radius: 0;
    box-shadow: 4px 4px 4px rgba(174, 222, 251, 0.1);
    border-top: none;

    .top-box-shadow {
      height: 2px;
      width: 100%;
      box-shadow: 3px 1px 8px 0 rgba(184, 222, 253, 0.4);
    }

    & > .custom-page-design-content {
      display: flex;
      align-items: center;
      height: calc(100% - 2px);
      width: 100%;
      background-color: #F5F9FE;

      .custom-page-design-left {
        width: 96px;
        height: 100%;
        background-color: #fff;
        border-right: 1px solid #EBEBEB;
        border-bottom-left-radius: 4px;
        box-shadow: 3px 1px 8px 0 rgba(184, 222, 253, 0.4);

        & > .title {
          padding: 25px 0 17px 0;
          text-align: center;
          font-size: 12px;
          color: #1A1A1A;
        }

        & > .controls {
          padding-left: 16px;
          height: calc(100% - 60px);
          overflow: auto;

          .control {
            width: 60px;
            height: 60px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(235, 235, 235, 1);
            border-radius: 4px;
            text-align: center;
            cursor: pointer;
            margin-bottom: 19px;
            padding-top: 8px;

            .el-image {
              height: 25px;
              width: 25px;
            }

            p {
              font-size: 14px;
              color: #1A1A1A;
            }

            &:hover {
              border-color: #55ACF1;

              p {
                color: #55ACF1;
              }
            }
          }
        }
      }

      .custom-page-design-right {
        height: 100%;
        width: calc(100% - 96px);
        position: relative;

        .none-controls {
          position: absolute;
          top: calc(50% - 120px);
          left: calc(50% - 117.5px);
          width: 235px;
          height: 140px;
          color: #666666;
          text-align: center;
          font-size: 14px;
          padding-top: 120px;
          background: url("assets/images/none.png") center top no-repeat;
        }

        .custom-page-design-controls {
          width: 100%;
          height: 100%;
          overflow-y: auto;
          overflow-x: hidden;
          position: relative;
          padding: 15px 15px 15px 0;

          & > .control {
            width: 100px;
            height: 100px;
            position: absolute;
            padding: 0 0 15px 15px;
            background-color: transparent;

            .control-body {
              height: 100%;
              width: 100%;
              border-radius: 4px;
              position: relative;
              cursor: pointer;
              overflow: auto;
              background-color: #fff;
              background-size: 100% 100%;

              .rich-value {
                padding: 15px;
                width: 100%;
                height: 100%;
                overflow: auto;

                img {
                  width: 100%;
                  height: 100%;
                }
              }

              .iframe-model {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 10;
                background-color: transparent;
              }

              .control-content {
                height: 100%;
                width: 100%;
                background-color: transparent;
                .text-control, .decorate {
                  height: 100%;
                  background-color: transparent;
                }
              }

              .control-content-has-title {
                height: calc(100% - 42px);
              }
            }

            .cursor-resize {
              cursor: nw-resize;
            }

            & > .el-icon-arrow-down {
              position: absolute;
              right: -1px;
              bottom: 14px;
              z-index: 9999;
              transform: rotate(-45deg);
              font-size: 16px;
              font-weight: 800;
              margin: 2px 0 0 2px;
              color: #A6A6A6;
              cursor: nw-resize;
            }

            .active {
              color: #8ECAF9;
              width: 25px;
              height: 25px;
              right: -13px;
              bottom: 9px;
              cursor: nw-resize;
            }

            .control-operation {
              position: absolute;
              top: 0;
              left: calc(50% - 45px);
              width: 90px;
              height: 26px;
              line-height: 26px;
              background-color: #3F3F3F;
              cursor: pointer;
              box-shadow: 0 2px 3px 0 rgba(4, 0, 0, 0.3);
              opacity: 0.9;
              border-radius: 2px;
              z-index: 20;

              &:hover {
                .control-body {
                  background-color: #000;
                }
              }

              span {
                color: #fff;
                display: inline-block;
                text-align: center;
                height: 26px;
                line-height: 26px;
                font-size: 12px;
                outline: none;
              }

              .el-icon-edit {
                width: 30px;

                &:hover {
                  color: #8ECAF9;
                }

                &:active {
                  color: #388DD2;
                }
              }

              .fa-text-height {
                width: 23px;
                padding-left: 11px;

                &:hover {
                  color: #8ECAF9;
                }

                &:active {
                  color: #388DD2;
                }
              }

              .disable-popover {
                cursor: no-drop;
              }

              .el-icon-error {
                width: 25px;

                &:hover {
                  color: #FB9391;
                }

                &:active {
                  color: #EE5451;
                }
              }

              &::after {
                content: '';
                display: block;
                position: absolute;
                top: 5px;
                left: 29px;
                width: 1px;
                height: 16.5px;
                background-color: #fff;
              }

              &::before {
                content: '';
                display: block;
                position: absolute;
                top: 5px;
                left: 53.5px;
                width: 4px;
                height: 14.5px;
                background-color: #3F3F3F;
              }
            }

            .update-width {
              width: 60px;
            }

            .control-title {
              width: 100%;
              height: 40px;
              line-height: 40px;
              padding: 5px 15px 0 15px;

              .el-input {
                background-color: transparent;
                border: none;
                height: 25px;
                line-height: 25px;
                border-radius: 0;
                color: #1A1A1A;
                font-size: 14px;

                .el-input__inner {
                  background-color: transparent;
                  border: none;
                  padding-left: 2px;
                  height: 25px;
                  line-height: 25px;
                  border-radius: 0;
                  color: inherit;
                  font-size: inherit;
                  font-family: inherit;
                  font-style: inherit;
                  font-weight: inherit;
                  text-decoration: inherit;

                  &:focus, &:active {
                    border-bottom: 1px solid #55ACF1;
                  }
                }
              }
            }

            .have-title-top {
              top: 38px;
            }
          }

          .control-animated {
            transition: all .6s;
          }

          .control-move-model {
            position: absolute;

            .control-move-model-body {
              width: 100%;
              height: 100%;
              background-color: #B8DEFD;
              opacity: .2;
            }
          }

          .set-z-index {
            z-index: 9995 !important;
          }
        }
      }
    }
  }

  .custom-page-design-dialog {
    .el-dialog {
      .el-dialog__body {
        padding: 0;

        .dialog-body {
          height: 576px;
          width: 100%;
        }
      }
    }

    .custom-page-design-dialog-title {
      text-align: left;
      font-size: 15px;
      width: calc(100% - 60px);
      height: 25px;
      line-height: 25px;
      display: flex;
      align-items: center;

      .el-icon-edit {
        color: #B6B8B9;
        cursor: pointer;

        &:hover {
          color: #60acfc;
        }

        &:active {
          color: #46a0fc;
        }
      }

      .title {
        max-width: calc(100% - 25px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 15px;
        color: #1A1A1A;
      }

      .show-input-width {
        width: calc(100% - 25px);

        .el-input {
          width: 100%;
          background-color: transparent;
          border: none;
          height: 25px;
          line-height: 25px;
          border-radius: 0;

          .el-input__inner {
            width: 100%;
            background-color: transparent;
            border: none;
            color: #1A1A1A;
            font-size: 15px;
            height: 25px;
            line-height: 25px;
            padding-left: 2px;
            border-radius: 0;

            &:focus, &:active {
              border-bottom: 1px solid #55ACF1;
            }
          }
        }
      }

      .operation {
        width: 25px;
        text-align: center;
      }
    }
  }

  .custom-page-popper {
    padding: 2px 5px;
    min-width: 30px;
  }

  .no-title-dialog {
    .el-dialog__header {
      .el-dialog__headerbtn {
        top: 2px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/custom-page-design.vue